import { render } from "./AdminProductListView.vue?vue&type=template&id=429fb7cb&ts=true"
import script from "./AdminProductListView.vue?vue&type=script&lang=ts"
export * from "./AdminProductListView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__